// src/styles/theme.ts (reverted to "previous" theme)
export const theme = {
  colors: {
    primary: '#008080', // Teal 
    secondary: '#666633', // Olive gray 
    background: '#e8ecef', // Softer gray 
    backgroundLight: '#ffffff', // Keep as white 
    text: '#ffffff', // Keep as white
    muted: '#b0bec5', // Lighter muted tone 
    success: '#2e7d32', // Darker green 
    warning: '#ffb300', // Amber 
    danger: '#d32f2f', // Darker red 
  },
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    title: {
      fontSize: '1.8rem',
      fontSizeLarge: '2.2rem',
      fontWeight: '600',
    },
    body: {
      fontSize: '1rem',
      fontSizeLarge: '1.2rem',
      lineHeight: '1.6',
    },
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
};